export const contextToBiEvent = context => {
  const {
    domain,
    area,
    page: {
      numLevels,
      urlChunks,
      topLevelRoute,
      queryParams
    },
    iframeUrlList,
    metaSiteId,
    platform,
    parentUrl,
    userId,
    userExperience,
    mappingProduct,
    mappingUrl
  } = context;
  const queryParamsStringified = Object.keys(queryParams).reduce((acc, key) => {
    const value = queryParams[key];
    acc += `${key}=${value},`;
    return acc;
  }, '').replace(/,\s*$/, '');
  return {
    context_area: area,
    context_domain: domain,
    context_iframeurllist: iframeUrlList.join(','),
    context_msid: metaSiteId,
    context_uuid: userId,
    context_platform: platform,
    context_parenturl: parentUrl,
    context_page_numlevels: numLevels,
    context_page_queryparams: queryParamsStringified,
    context_page_toplevelroute: topLevelRoute,
    context_page_urlchunks: urlChunks.join(','),
    mapping_url: mappingUrl,
    mapping_product: mappingProduct,
    user_experience: userExperience
  };
};
export let ChatbotView = /*#__PURE__*/function (ChatbotView) {
  ChatbotView["helpWidgetContactPage"] = "helpWidgetContactPage";
  ChatbotView["helpWidgetFloating"] = "helpWidgetFloating";
  ChatbotView["editor"] = "editor";
  return ChatbotView;
}({});
const FULL_PAGE_HC_ROUTE = 'widget';
export const getChatbotView = context => {
  if (!(context != null && context.page)) {
    return null;
  }
  if (context.area === 'editor') {
    return ChatbotView.editor;
  }
  const helpCenterIframe = context.page.numLevels === 2 && context.page.urlChunks.includes(FULL_PAGE_HC_ROUTE);
  if (helpCenterIframe || context.page.numLevels === 1) {
    return ChatbotView.helpWidgetContactPage;
  }
  return ChatbotView.helpWidgetFloating;
};
//# sourceMappingURL=contextToBiEvent.js.map